import { ModelBase, NeoModel } from '@singularsystems/neo-core'
import { injectable } from 'inversify';
import { AppService, Types } from '../ClientsTypes';

@injectable()
@NeoModel
export default class ChatbotService extends ModelBase {

    public constructor(
        public taskRunner = AppService.get(Types.Neo.TaskRunner),
        private clientsApiClient = AppService.get(Types.Clients.ApiClients.ClientsApiClient),
    ) {
        super();
    }

    public chatbotURL: string = '';

    public async initialise() {
        const urlResponse = await this.clientsApiClient.getChatbotURL();
        this.chatbotURL = urlResponse.data;
    }
}